// 修正非 ISO 8601 格式的日期时间字符串
export function normalizeDate(date: string) {
  if (date.length === 19) {
    return `${date.replace(' ', 'T')}+08:00`;
  }

  return date;
}

export function isDateBetween(start?: string, end?: string) {
  if (!start || !end) {
    return false;
  }

  start = normalizeDate(start);
  end = normalizeDate(end);

  const min = new Date(start).getTime();
  const max = new Date(end).getTime();
  const now = new Date().getTime();

  return now >= min && now <= max;
}

export function isDateSameOrAfter(target: string) {
  target = normalizeDate(target);

  const currentTime = new Date().getTime();
  const targetTime = new Date(target).getTime();

  return currentTime >= targetTime;
}

export function isDateAfter(target: string) {
  target = normalizeDate(target);

  const currentTime = new Date().getTime();
  const targetTime = new Date(target).getTime();

  return currentTime > targetTime;
}
